import { useLocation, useNavigate, Outlet } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

function PamPage() {
  const location = useLocation()
  const navigate = useNavigate()

  // 根据路径判断当前 Tab
  const currentTab = location.pathname.includes('/create') ? 'create' : 'import'

  const handleTabChange = (value) => {
    if (value === 'import') {
      navigate('/admob/pam')
    } else {
      navigate('/admob/pam/create')
    }
  }

  return (
    <div className="p-6">
      <Tabs value={currentTab} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="import">Mediation A/B</TabsTrigger>
          <TabsTrigger value="create">PAM Create</TabsTrigger>
        </TabsList>
      </Tabs>
      {/* 使用 Outlet 渲染子路由 */}
      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  )
}

export default PamPage
